import { CartAddEvent } from '@theme/events';

// Global event delegation — handles dynamic content reliably
document.addEventListener('click', (event) => {
  const addGiftButton = event.target.closest('.js-add-gift');
  if (addGiftButton) {
    handleAddOrUpdateGift(addGiftButton);
    return;
  }

  const updateGiftButton = event.target.closest('.js-update-gift');
  if (updateGiftButton) {
    handleOpenGiftMessage();
    return;
  }
});

async function handleAddOrUpdateGift(addGiftButton) {
  const messageInput = document.querySelector('.js-gift-message');
  const variantId = addGiftButton?.dataset.id;
  const type = addGiftButton?.dataset.type; // "add" or "update"
  const message = messageInput?.value?.trim() || '';

  if (!variantId) {
    console.error('Gift wrap: Variant ID missing');
    return;
  }

  const properties = {
    'Gift Message': message,
    '_gift_wrap': true,
  };

  try {
    if (type === 'update') {
      const lineItemElement = document.querySelector('.cart-items__table-row[data-line-item-key]');
      if (lineItemElement) {
        const lineItemKey = lineItemElement.dataset.lineItemKey;

        await fetchJson('/cart/change.js', {
          method: 'POST',
          body: JSON.stringify({
            id: lineItemKey,
            quantity: 1,
            properties,
          }),
        });

        document.dispatchEvent(new CartAddEvent());

        const details = document.querySelector('.gift-message');
        if (details) details.open = false;

        return;
      }
    }

    // Add flow
    await refreshCart();

    await fetchJson('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties,
      }),
    });

    document.dispatchEvent(new CartAddEvent());

    const details = document.querySelector('.gift-message');
    if (details) details.open = false;

  } catch (error) {
    console.error('Gift wrap error:', error);
  }
}

function handleOpenGiftMessage() {
  const details = document.querySelector('.gift-message');
  if (details) {
    details.open = true;
    const messageInput = document.querySelector('.js-gift-message');
    if (messageInput) messageInput.focus();
  }
}

async function fetchJson(url, options = {}) {
  const fetchOptions = {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  };

  const response = await fetch(url, fetchOptions);
  if (!response.ok) {
    const errorText = await response.text().catch(() => '');
    throw new Error(`Fetch error ${response.status} on ${url}: ${errorText}`);
  }
  return response.json();
}

async function refreshCart() {
  try {
    await fetchJson('/cart.js');
  } catch (err) {
    console.warn('Cart refresh failed but continuing anyway:', err);
  }
}
